// extracted by mini-css-extract-plugin
module.exports = {"chatLinkText":"ChatLink_chatLinkText__pVXI1","chatLink":"ChatLink_chatLink__4WtW-","textBlack":"ChatLink_textBlack__3eihO"};